import React from 'react'
import {Applications} from '../Pages/Applications/Applications'

function ApplicationsPage() {
  return (
    <>
        <Applications />
    </>
  )
}

export default ApplicationsPage
